<neo-form-field [attr.data-aut-id]="autId() + '-field'" [subscriptSizing]="subscriptSizing()">
  <neo-label>{{ label() }}</neo-label>

  <!-- Search icon prefix - decorative only -->
  <span neoPrefix class="search-icon-prefix" aria-hidden="true">
    <cm-icon name="search" size="md" />
  </span>

  <input
    type="text"
    neoInput
    [neoAutocomplete]="auto"
    [placeholder]="placeholder()"
    [required]="required()"
    [disabled]="disabled()"
    [value]="selectedDisplayText() || searchValue()"
    (input)="onSearchChange($event)"
    (blur)="onInputBlur()"
    [attr.aria-describedby]="hint() ? autId() + '-hint' : null"
    [attr.data-aut-id]="autId() + '-input'"
    [attr.aut-id]="autId() + '-input'"
  />

  @if (showClearButton() && selectedOption()) {
    <cm-button
      variant="basic"
      color="gray"
      [iconOnly]="true"
      neoSuffix
      ariaLabel="Clear selection"
      tooltip="Clear selection"
      (click)="onClear()"
      [disabled]="disabled()"
      [attr.data-aut-id]="autId() + '-clear-btn'"
      [attr.aut-id]="autId() + '-clear-btn'"
    >
      <cm-icon name="close" size="s" aria-hidden="true" />
    </cm-button>
  }

  <neo-autocomplete-v2
    #auto="neoAutocomplete"
    [requireSelection]="true"
    [displayWith]="_neoDisplayWith()"
    (optionSelected)="onOptionSelected($event)"
    (closed)="onPanelClosed()"
  >
    @if (loading()) {
      <neo-option [value]="null" [disabled]="true">
        <span class="loading-text">Loading...</span>
      </neo-option>
    } @else if (_allOptions().length === 0 && (searchValue() || _hasSearched())) {
      <neo-option [value]="null" [disabled]="true">
        <span class="no-results-text">No results found</span>
      </neo-option>
    } @else if (hasGroups()) {
      @for (group of optionGroupVms(); track group.label) {
        <neo-optgroup [label]="group.label">
          @for (optionVm of group.options; track optionVm.key) {
            <neo-option [value]="optionVm.option">
              @if (optionTemplate()) {
                <ng-container *ngTemplateOutlet="optionTemplate()!; context: { $implicit: optionVm.option }" />
              } @else {
                <span class="option-text">{{ optionVm.label }}</span>
              }
            </neo-option>
          }
        </neo-optgroup>
      }
    } @else {
      @for (optionVm of optionVms(); track optionVm.key) {
        <neo-option [value]="optionVm.option">
          @if (optionTemplate()) {
            <ng-container *ngTemplateOutlet="optionTemplate()!; context: { $implicit: optionVm.option }" />
          } @else {
            <span class="option-text">{{ optionVm.label }}</span>
          }
        </neo-option>
      }
    }
  </neo-autocomplete-v2>

  <cm-field-errors
    [control]="ngControl()?.control ?? null"
    [label]="label()"
    [customMessages]="errorMessages()"
    [showErrorsWhen]="showErrorsWhen()"
    [hideErrors]="hideErrors()"
  />
</neo-form-field>

@if (hint()) {
  <neo-hint [id]="autId() + '-hint'">{{ hint() }}</neo-hint>
}
